module.exports = __webpack_public_path__ + "static/mohammed-and-charlemagne-622b2430a2e9a31f713abc3e27d777fb.jpg";